import { createReducer, on } from '@ngrx/store';

import { IAppendixesState, initialAppendixesState } from './appendix.state';
import { AppendixesLoaded, AppendixTypesLoaded } from './appendix.actions';


export const initialState: IAppendixesState = {
  appendixes: [],
  appendixTypes: []
};

const setAppendixes = (state: IAppendixesState, { appendixes }: { appendixes: any[] }) => ({
  ...state,
  appendixes
});

const setAppendixTypes = (state: IAppendixesState, { appendixTypes }: { appendixTypes: any[] }) => ({
  ...state,
  appendixTypes
});

const _appendixesReducer = createReducer<IAppendixesState>(
  initialAppendixesState,
  on(AppendixesLoaded, setAppendixes)
);

const _appendixTypesReducer = createReducer<IAppendixesState>(
  initialAppendixesState,
  on(AppendixTypesLoaded, setAppendixTypes)
);

export function appendixesReducer(state: IAppendixesState, action): IAppendixesState {
  return _appendixesReducer(state, action);
}

export function appendixTypesReducer(state: IAppendixesState, action): IAppendixesState {
  return _appendixTypesReducer(state, action);
}
